import { render, staticRenderFns } from "./FullCarView.vue?vue&type=template&id=2b34fd8c&"
import script from "./FullCarView.vue?vue&type=script&lang=js&"
export * from "./FullCarView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports